// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Info = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Info = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Info = _exports.Info = function Info(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99935 1.66699C5.39685 1.66699 1.66602 5.39783 1.66602 10.0003C1.66602 14.6028 5.39685 18.3337 9.99935 18.3337C14.6018 18.3337 18.3327 14.6028 18.3327 10.0003C18.3327 5.39783 14.6018 1.66699 9.99935 1.66699ZM10.6243 13.7503C10.6243 14.0953 10.3443 14.3753 9.99935 14.3753C9.65435 14.3753 9.37435 14.0953 9.37435 13.7503V9.94112C9.37435 9.59612 9.65435 9.31612 9.99935 9.31612C10.3443 9.31612 10.6243 9.59612 10.6243 9.94112V13.7503ZM10.016 7.91699C9.55603 7.91699 9.17843 7.54366 9.17843 7.08366C9.17843 6.62366 9.54769 6.25033 10.0077 6.25033H10.016C10.4769 6.25033 10.8494 6.62366 10.8494 7.08366C10.8494 7.54366 10.476 7.91699 10.016 7.91699Z",
      fill: "currentColor"
    }));
  };
});
